import './FullscreenSpinner.css'

function FullscreenSpinner({ open = false, label = 'Загрузка…' }) {
  if (!open) return null

  return (
    <div className="client-fullscreenSpinner" role="status" aria-live="polite" aria-label={label}>
      <div className="client-fullscreenSpinner-backdrop" aria-hidden="true" />
      <div className="client-fullscreenSpinner-card">
        <div className="client-fullscreenSpinner-ring" aria-hidden="true" />
        <div className="client-fullscreenSpinner-text">{label}</div>
      </div>
    </div>
  )
}

export default FullscreenSpinner

